import { deliverDatabaseChange } from "./database-change-transaction-buffer.ts";
import { addManualDatabaseChangeListener } from "./manual-change-listener.ts";

// On web there is no upstream `expo-sqlite` native module — every write flows
// through the leader-tab broker via `WebSqliteDatabase`, which emits via
// `emitManualDatabaseChange` on every mutating statement. Subscribing to that
// emitter is sufficient.
// Deliveries route through the transaction buffer so per-statement events fired
// mid-transaction reach listeners only once the transaction settles — see
// `database-change-transaction-buffer.ts`.
export function addDatabaseChangeListener(
  listener: (event: {
    databaseFilePath: string;
    databaseName: string;
    rowId: number;
    tableName: string;
  }) => void,
): { remove(): void } {
  return addManualDatabaseChangeListener((event) => {
    deliverDatabaseChange(listener, event);
  });
}
